import validator from 'validator'

export const validateSimpleString = (str: string) => !!str.trim()

export const validateEmail = (email: string) => validator.isEmail(email)

export const validatePhone = (phone: string) => validator.isMobilePhone(phone)
